import * as requests from '../api-request'

export const createWorkspace = async (data) => {
  return requests.toJSON('POST', 'workspace', data)
}

export const getWorkspaces = async () => {
  return requests.toJSON('GET', 'workspace')
}

export const getRemovalNotice = async (workspaceId) => {
  return requests.toJSON('GET', `workspace/removal-notice/${workspaceId}`)
}

export const switchWorkspace = async (data) => {
  return requests.toJSON('POST', 'workspace/switch', data)
}

export const getMembers = async (workspaceId) => {
  return requests.toJSON('GET', `workspace/${workspaceId}/members`)
}

export const inviteUser = async (workspaceId, data) => {
  return requests.toJSON('POST', `workspace/${workspaceId}/invite`, data)
}

export const resendInvite = async (workspaceId, data) => {
  return requests.toJSON('POST', `workspace/${workspaceId}/invite/resend`, data)
}

export const cancelInvite = async (workspaceId, invitationId) => {
  return requests.toJSON('DELETE', `workspace/${workspaceId}/invite/${invitationId}`)
}

export const removeMember = async (workspaceId, memberId) => {
  return requests.toJSON('DELETE', `workspace/${workspaceId}/member/${memberId}`)
}

export const acceptInvitation = async (data) => {
  return requests.toJSON('POST', 'workspace/invitation/accept', data)
}

export const getStats = async (workspaceId) => {
  return requests.toJSON('GET', `workspace/${workspaceId}/stats`)
}

export const updateWorkspace = async (workspaceId, data) => {
  return requests.toJSON('PATCH', `workspace/${workspaceId}`, data)
}

export const uploadLogo = async (workspaceId, file) => {
  const formData = new FormData() // eslint-disable-line no-undef
  formData.append('file', file)
  return requests.toJSON('POST', `workspace/${workspaceId}/upload_logo`, formData, null, false)
}

export const getKnowledge = async (workspaceId) => {
  return requests.toJSON('GET', `workspace/${workspaceId}/knowledge`)
}
